
import { FinancialInstitution, Occupation, FundmoreRequestDto } from "@/lib/DTMWebAPIClient.generated";
import { assetInfo } from "@/slices/assetSlice";
import { currentEmploymentInfo } from "@/slices/currentEmploymentSlice";
import { expenseInfo } from "@/slices/expenseSlice";
import { fundmoreSSO } from "@/slices/sessionDataSlice";
import { applicantType } from "./applicantType";


export interface applicationType {
  "id": number,
  "status": string,
  "applicationCategory": applicationCategory | 0,
  "searchingForProperty": boolean,
  "termLength": number | string,
  "amortizationLength": number | string,
  "downPayment": number,
  "totalLoan": number,
  "productId": string[],
  "isCoApplicant": boolean,
  "jointCode": string,
  "jointRelationship": string,
  "jointPrimaryApplicant": string,
  "jointAccepted": boolean,
  "products": any,
  "selectedProducts": any,
  "promoCode": string,
  "applicationEndpointReached": boolean,
  "applicationErrorCode": string,
  "applicationErrorMessage": string,
  "applicationProgress": number,
  "skipAlloy": boolean,
  "alloyApplicationToken": string,
  "blResult": boolean,
  "welcomeEmailSent": boolean,
  "idVerificationSubmitted": boolean,
  "underStaffReview": boolean,
  "purchaseTypeSelected": boolean,
}

export enum applicationCategory {
  Buy = 1,
  Refinance,
  Transfer
}

export enum verificationCategory {
  Pending = 0,
  Processing,
  Pass,
  Softfail,
  Hardfail,
  Submit
}

export interface sessionDataType {
  "occupations": Occupation[],
  "financialInstitutions": FinancialInstitution[],
  "cachedApplicant": applicantType | undefined,
  "cachedCurrentEmployment": currentEmploymentInfo[],
  "cachedAssets": assetInfo[],
  "cachedExpenses": expenseInfo[],
  "fundmoreSSO": fundmoreSSO | undefined
}